//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/Builder.js";
let d=[[[0,"AnimalsIconOnly",1,0],[0,"CarsIconTextMenu",1,0],[0,"ConstraintsPalette",1,0],[0,"CurvesPalette",1,0],[0,"DancesHorizontalRadio",1,0],[0,"FruitTextOnly",1,0],[0,"TreesVerticalRadio",1,0]],[],[]];
SPLM.GeometricUtilities.EnumTest = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.EnumTest";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.EnumTest.Fruit = Object.freeze({
    "Apple" : "Apple", "Pear" : "Pear"});

SPLM.GeometricUtilities.EnumTest.Animals = Object.freeze({
    "Pika" : "Pika", "Aardvark" : "Aardvark", "Hippo" : "Hippo", "Snake" : "Snake"});

SPLM.GeometricUtilities.EnumTest.Cars = Object.freeze({
    "Mustang" : "Mustang", "Edsel" : "Edsel", "Tucker" : "Tucker", "Citroen" : "Citroen"});

SPLM.GeometricUtilities.EnumTest.Trees = Object.freeze({
    "Willow" : "Willow", "Pine" : "Pine", "Gingko" : "Gingko"});

SPLM.GeometricUtilities.EnumTest.Dances = Object.freeze({
    "HokeyPokey" : "HokeyPokey", "HokeyWaltz" : "HokeyWaltz", "HokeyBird" : "HokeyBird"});

SPLM.GeometricUtilities.EnumTest.Curves = Object.freeze({
    "Line" : "Line", "Arc" : "Arc", "Circle" : "Circle"});

SPLM.GeometricUtilities.EnumTest.Constraints = Object.freeze({
    "Coincident" : "Coincident", "Parallel" : "Parallel", "Colinear" : "Colinear", "Concentric" : "Concentric", "EqualRadius" : "EqualRadius", "Fixed" : "Fixed"});

export default SPLM;